export default "__VITE_ASSET__e29bd6c0__"